export default {
  meta: {
    title: '成本中心',
    parentPath: '/intelligent',
    breadcrumbs: ['智能运营', '成本中心'],
  }
};
